import React from 'react';
import { BasicContainer, GridDynamic, H1Text } from '@minecraft.atoms';
import { SubNav } from '../SubNav';
import { BasicLayoutProps } from './types';

const FULL = { start: '1', end: '13' }; // 12 columns no padding
const BodyWidthMap = {
  sm: {
    mobile: FULL,
    sm: { start: '3', end: '11' }, // 2 columns padding on each side
    md: { start: '4', end: '10' }, // 3 columns padding on each side
    lg: { start: '4', end: '10' }, // 3 columns padding on each side
  },
  md: {
    mobile: FULL,
    sm: { start: '2', end: '12' }, // 1 column padding on each side
    md: { start: '3', end: '11' }, // 2 columns padding on each side
    lg: { start: '3', end: '11' }, // 2 columns padding on each side
  },
  lg: {
    mobile: FULL,
    sm: { start: '2', end: '12' }, // 1 column padding on each side
    md: { start: '2', end: '12' }, // 1 column padding on each side
    lg: { start: '2', end: '12' }, // 1 column padding on each side
  },
  full: { mobile: FULL, sm: FULL, md: FULL, lg: FULL },
};

export const BasicLayout = <NavKey extends string>({
  header,
  children,
  pageBgColor = 'card',
  bodyMaxWidth,
  subNavProps,
  pageTitle,
  'data-testid': dataTestId = 'basic-layout',
  scrollRef,
}: BasicLayoutProps<NavKey>) => {
  const BodyWidth = BodyWidthMap[bodyMaxWidth || 'full'];
  return (
    <BasicContainer h="screen" className="cn_overflow-hidden" data-testid={dataTestId} bgColor={pageBgColor}>
      <BasicContainer
        h="screen"
        className="cn_overflow-auto"
        data-testid={`${dataTestId}-scroll-wrapper`}
        ref={scrollRef}
      >
        {header}
        {subNavProps && <SubNav {...subNavProps} />}
        <GridDynamic columns="repeat(12, 1fr)" h="full" data-testid="layout-grid-container">
          <BasicContainer
            data-testid="layout-grid-content"
            gridColumnStart={BodyWidth.mobile.start}
            gridColumnEnd={BodyWidth.mobile.end}
            smProps={{ gridColumnStart: BodyWidth.sm.start, gridColumnEnd: BodyWidth.sm.end }}
            mdProps={{ gridColumnStart: BodyWidth.md.start, gridColumnEnd: BodyWidth.md.end }}
            lgProps={{ gridColumnStart: BodyWidth.lg.start, gridColumnEnd: BodyWidth.lg.end }}
          >
            {pageTitle && (
              <BasicContainer data-testid="page-title-wrapper" borderPlacement="bottom" className="cn_atom_py-6">
                <H1Text as="h2">{pageTitle}</H1Text>
              </BasicContainer>
            )}
            {children}
          </BasicContainer>
        </GridDynamic>
      </BasicContainer>
    </BasicContainer>
  );
};
